import BaseEntityService from "core/framework/BaseEntityService";
import { getLogger } from "core/utils";

const log = getLogger("BaseProductService");

export default class BaseProductService extends BaseEntityService {
  constructor({ baseUrl }) {
    super({ baseUrl });
  }

  /*
  beforeSave({ instance }) {
    instance = JSON.parse(JSON.stringify(instance));
    if (instance.statuses && instance.statuses.length) {
      for (let status of instance.statuses) {
        if (status.outgoingArrows && status.outgoingArrows.length) {
          for (let arrow of status.outgoingArrows) {
            if (arrow.toStatus) {
              arrow.toStatus.tagAlternatives = undefined;
              arrow.toStatus.primaryActor = undefined;
            }
          }
        }
      }
    }

    return instance;
  }
  */

  async evaluate({ parameters, pageRequest, sort, requestId }) {
    log.debug("Evaluating ", parameters, pageRequest, sort, requestId);
    return await this.get({
      url: this.baseUrl + "/evaluate/" + requestId,
      queryParams: [
        parameters,
        pageRequest
          ? { page: pageRequest.number, size: pageRequest.size }
          : { page: 0, size: 0 },
        sort ? { sort: sort.sort, order: sort.order.toUpperCase() } : {}
      ]
    });
  }

  async createFile({ productId, requestId }) {
    log.debug("Creating file ", productId, requestId);
    return await this.post({
      url: this.baseUrl + "/" + productId + "/init/" + requestId
    });
  }
}
